import { Component, OnDestroy, OnInit, Input } from '@angular/core';
import { LogService } from 'app/_services/logmanager.service';
import { AlertService } from 'app/_services/alert.service';
import { DataService } from 'app/_services/datamanager.service';
import { GlobalsService } from 'app/_services/globals.service';
import { takeWhile } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'sec-consultes-csv',
    templateUrl: './consultes-csv.component.html'
})
export class ConsultesCsvComponent implements OnInit, OnDestroy {
    
    @Input() categories = '';
    @Input() convocatoriaActiva = '';
    @Input() incloureTots = false;
    alive = true;
    queries = [];
    cursos = [];
    estatsPagament = [];
    estatsMatricula = [];
    convocatories = [];
    moduls = [];
    seus = [];
    centres = [];
    centres_filtrats = [];
    selectDefault = '';
    curs = 0;
    error = false;



    constructor(private alertService: AlertService,
                private dataService: DataService,
                private globalStorage: GlobalsService
    ) {
    }

    ngOnInit() {
        LogService.log('PafsGestioComponent', 'Pantalla Pafs gestio cargado');
        this.getCentres();
        this.getConvocatories();
        this.getEstatsMatricula();
        this.getEstatsPagament();
        this.getCursosEspecialitzacio();
        this.getConsultesCSV();
    }

    getConsultesCSV() {
        const params = <any>{
            'accio': 'WsGetConsultesSecretaria',
            'params': <any> {
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
                'categories' : this.categories
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                if (data[0]) {
                    this.queries = data[0];
                    this.queries.forEach(query => {
                        query.params = {
                            'convocatoria': '',
                            'alumne': '',
                            'estatMatricula': 1,
                            'estatPagament': 'Normal',
                            'curs': '',
                            'modul': '',
                            'seu': '',
                            'centre': '',
                        }
                    });
                }
            }
        );
    }

    getCentres() {
        const params_centres = <any> {
            'accio': 'WsGetCentresPafs',
            'params': <any>{
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
            }
        };

        this.dataService.getData(params_centres)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                if(this.incloureTots){
                    this.seus = [];
                    this.seus.push({id: 0, codi: 'tots', nom: 'Totes', actiu: 'Si'});
                }
                this.seus = this.seus.concat(data[0].seus);
                this.centres = data[0].centres;
            }
        );
    }

    getConvocatories() {
        const params = <any>{
            'accio': 'WsGetConvocatoriesSecretaria',
            'params': <any> {
                'secretaria_id' : this.globalStorage.getItem('secretaria')
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('AdministracioComponent', data);
                this.convocatories = data[0];
            }
        );
    }

    getEstatsMatricula() {
        const params = <any>{
            'accio': 'WsGetEstatsMatricula',
            'params': <any>{
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('AdministracioComponent', 'administra: '+data[0]);
                this.estatsMatricula = data[0];
                this.selectDefault = '1'; // Estat per defecte
            }
        );
    }

    getEstatsPagament(){
        const params = <any>{
            'accio': 'WsGetEstatsPagament',
            'params': <any>{
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('AdministracioComponent', 'administra: '+data[0]);
                this.estatsPagament = data[0];
                this.selectDefault = '1'; // Estat per defecte
            }
        );
    }

    getCursosEspecialitzacio(){
        const params = <any>{
            'accio': 'WsGetCursos',
            'params': <any>{
                'secretaria_id': this.globalStorage.getItem('secretaria'),
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                this.cursos = [];
                LogService.log('AdministracioComponent', 'Cursos: '+data[0]);
                if(this.incloureTots){
                    this.cursos.push({ id: 0, codi: 'tots', nom: 'Tots'})
                }
                this.cursos = this.cursos.concat(data[0]);
            }
        );
    }

    onChangeCursEspecialitzacio(params: any){
        this.curs = params.curs;
        this.getModulsCursEspecialitzacio(params);
    }

    // onChangeSeu(seu: number){
    //     this.centres_filtrats = this.centres.filter(centre => centre.id == seu)
    // }

    getModulsCursEspecialitzacio(props: any){
        const params = <any>{
            'accio': 'WsGetModulsCursEspecialitzacio',
            'params': <any>{
                'secretaria_id': this.globalStorage.getItem('secretaria'),
                'curs': this.curs,
                'convocatoria': props.convocatoria
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                this.moduls = [];
                LogService.log('AdministracioComponent', 'cursEspe_curs: '+this.curs);
                LogService.log('AdministracioComponent', 'cursEspe_moduls:'+data[0]);
                if(this.incloureTots){
                    this.moduls.push({id: 0, codi: '*', nom: 'Tots'});
                }
                this.moduls = this.moduls.concat(data[0]);
            }
        );
    }

    /**
     * Convierte el objeto JSON en un string separado por comas
     * @param objArray
     * @returns {string}
     */
    ConvertToCSV(objArray: any) {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';
        let row = '';

        for (const index in objArray[0]) {
            if (objArray[0].hasOwnProperty(index)) {
                // Convertimos cada valor en un string separado por comas
                row += index + ';';
            }
        }
        row = row.slice(0, -1);
        // Añade un salto de linea
        str += row + '\r\n';

        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (const index in array[i]) {
                if (array[i].hasOwnProperty(index)) {
                    if (line !== '') {
                        line += ';';
                    }
                    line += array[i][index];
                }
            }
            str += line + '\r\n';
        }
        return str;
    }


    checkAlumneByInput(username: string){

        const params = <any>{
            'accio': 'WsCheckAlumneByInput',
            'params': <any> {
                'secretaria_id' : this.globalStorage.getItem('secretaria'),
                'username': username
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {
                LogService.log('AdministracioComponent', 'paramsARASI: '+JSON.stringify(data[0]));
            
                if (parseInt(data[0].estat, 10) !== 100) {
                    this.error = true;
                    this.alertService.error(<any>data[0].missatge);
                }else{
                    this.error = false;
                }
            }
        );
    }



    extreureCsv(tipusConsulta: any, nomarxiu: string, nomConsulta: string, queryParams: any, action: string) {

        // Comprova que existeixi l'alumne a CEFP només per la consulta 2.
        if(tipusConsulta == 2){
            this.checkAlumneByInput(queryParams.alumne);
        }
        
        // Mostra missatge si no es seleccion el curs i el mòdul.
        if(tipusConsulta == 5 && (!queryParams.curs || !queryParams.modul)){
            this.alertService.error('Falten camps per omplir per la consulta: '+nomConsulta);
            return;
        }

        // Evita error, al no trobar dades per les consultes que no fan servir
        // aquest dos camps.
        if (tipusConsulta != 5) {
            queryParams.curs = typeof queryParams.curs === undefined ? '' : queryParams.curs;
            queryParams.modul = typeof queryParams.modul === undefined ? '' : queryParams.modul;
        }

        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.convocatoria));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.alumne));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.estatMatricula));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.estatPagament));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.curs));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.modul));
        LogService.log('extreureCsv', 'paramsARASI: ' + JSON.stringify(tipusConsulta + nomarxiu + queryParams.alumne));

        const params = <any>{
            'accio': action,
            'params': <any>{
                'secretaria_id': this.globalStorage.getItem('secretaria'),
                'tipus_consulta': tipusConsulta,
                'convocatoria': queryParams.convocatoria,
                'alumne': queryParams.alumne,
                'estatMatricula': queryParams.estatMatricula,
                'estatPagament': queryParams.estatPagament,
                'curs': queryParams.curs,
                'modul': queryParams.modul,
                'seu' : queryParams.seu,
                'centre' : queryParams.centre
            }
        };

        this.dataService.getData(params)
            .pipe(takeWhile(() => this.alive))
            .subscribe(
            data => {

                if (!data[0]) {
                    this.alertService.error('No s\'ha trobat cap resultat per la consulta: '+nomConsulta);
                }else{

                    const csvData = this.ConvertToCSV(data[0]);
                    const blob    = new Blob([csvData], {type: 'text/csv; charset=utf-8;'});

                    // IE11 & Edge
                    if (navigator.msSaveBlob) {
                        navigator.msSaveBlob(blob, nomarxiu+'.csv');
                    } else {
                        // En FF el link debe ser añadido al DOM
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.setAttribute('download', nomarxiu+'.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    }
                }
            });
    }

    ngOnDestroy() {
        this.alive = false;
    }


}